<template>
  <div class="turn-paper-outer">
    <div class="turn-book-container">
      <div class="page-wrapper book-viewport" id="book" :page="Number(currentPageNum) + 1">
        <img v-if="pages[currentPageNum] && pages[currentPageNum].url" id="paperImg" class="page-img" @load="goload(currentPageNum)" :src="pages[currentPageNum].url" alt="" />
        <template v-if="isReady && bookData.pages && bookData.pages.length > 0">
          <div
            v-for="(coord, coordindex) in bookData.pages[currentPageNum].coordinates"
            v-bind:key="coordindex + 100"
            class="res-node area"
            :data-index="coordindex"
            :data-type="coord.type"
            :style="{
              top: coord.topScale + 'px',
              left: coord.leftScale + 'px',
              width: coord.widthScale + 'px',
              height: coord.heightScale + 'px',
              zIndex: coord.zIndex + 10
            }"
            @click="resNodeClick($event, coord, bookData.pages[currentPageNum])"
          ></div>
          <div
            v-for="(res, resindex) in bookData.pages[currentPageNum].resources"
            v-bind:key="resindex"
            :class="{ 'res-node': true, audio: res.type === 'audio', video: res.type === 'video', link: res.type === 'link', picture: res.type === 'picture' }"
            :data-index="resindex"
            :data-type="res.type"
            :style="{
              top: res.topScale + 'px',
              left: res.leftScale + 'px',
              width: res.widthScale + 'px',
              height: res.heightScale + 'px',
              'z-index': res.type === 'picture' ? 1 : res.zindex + 101,
              'background-image': res.type === 'picture' ? `url(${res.path})` : ''
            }"
            @click="resNodeClick($event, res, bookData.pages[currentPageNum])"
          >
            <img :src="res.btnPath && res.btnStyle == 1 ? res.btnPath : audioDefaultIcon" v-if="res.type === 'audio'" @click="resNodeImgClick($event, res)" v-singletap="resNodeImgSingletap" />
            <img :src="res.btnPath && res.btnStyle == 1 ? res.btnPath : videoDefaultIcon" v-else-if="res.type === 'video'" @click="resNodeImgClick($event, res)" v-singletap="resNodeImgSingletap" />
            <img :src="res.btnPath && res.btnStyle == 1 ? res.btnPath : linkDefaultIcon" v-else-if="res.type === 'link'" />
          </div>
        </template>
      </div>
      <div class="page-opt">
        <h4 v-if="pages[currentPageNum]">{{ currentLang === 1 ? 'Current page: 0' + pages[currentPageNum].pageNo : '当前版：0' + pages[currentPageNum].pageNo + '版' }}</h4>
        <div>
          <span @click="first">{{ currentLang === 1 ? 'First' : '首版' }}</span>
          <span @click="prev">{{ currentLang === 1 ? 'Previous' : '上一版' }}</span>
          <span @click="next">{{ currentLang === 1 ? 'Next' : '下一版' }}</span>
          <span @click="last">{{ currentLang === 1 ? 'Last' : '末版' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import getBook from '@api/getBook'
import Thick from '../../../assets/audios/thick.mp3'
import Soft from '../../../assets/audios/soft.mp3'
import Default from '../../../assets/audios/default.mp3'
import turnBookMixin from './turnBookMixin.js'
import wx from 'weixin-js-sdk'
import { isPureNum, judgeIsMobile, judgeMI8 } from '@/utils'
import { mapState } from 'vuex'
import home from '@api/home'

export default {
  name: 'paperPage',
  mixins: [turnBookMixin],
  props: {
    initPageIndex: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      isPaper: true, // TODO 接口返回参数 是否为数字报
      isMI8: judgeMI8(),
      mobile: {
        tMatrix: [1, 0, 0, 1, 0, 0],
        initScale: 1,
        ticking: false,
        el: null,
        poscenter: null,
        lastTranslate: null,
        lastcenter: null,
        center: null,
        duration: '',
        maxScale: 9,
        minScale: 1
      },
      isReady: false,
      playSrc: Default,
      audio: {
        Thick,
        Soft,
        Default
      },
      isloading: [],
      decryption_id: isPureNum(this.$route.query.id),
      readingLog: null,
      // zjx 20221219 当前页面索引，从1开始
      currentPageIndex: this.initPageIndex,
      bgAudioPlayStatus: false,
      currentResNodeDataIndex: 0, // 当前激活的音视频按钮的索引
      mediaSrc: {
        audioSrc: '',
        videoSrc: '',
        linkSrc: ''
      },
      audioDefaultIcon: require('@imgs/digital/audio.png'),
      videoDefaultIcon: require('@imgs/digital/video.png'),
      isShowContent: true,
      linkDefaultIcon: require('@imgs/digital/link.png')
    }
  },
  computed: {
    ...mapState('book', ['bookPath', 'play', 'isShowYellow', 'isShowCommerHeader', 'totalPage']),
    shareTitle() {
      return this.$store.state.config.bookObj.shareTitle
    },
    referer() {
      return this.$store.state.config.bookObj.referer && this.$store.state.config.bookObj.referer < this.totalPage ? this.$store.state.config.bookObj.referer : 1
    },
    bookHeight() {
      return this.$store.state.common.bookSize.bookHeight
    },
    bookWidth() {
      return this.$store.state.common.bookSize.bookWidth
    },
    bookScale() {
      return this.$store.state.common.bookScale
    },
    soundId() {
      return this.$store.state.config.bookObj.soundId
    },
    longPress() {
      return this.$store.state.config.bookObj.longPress
    },
    isStaticBook() {
      return this.$store.state.common.isStaticBook
    },
    // zjx 20221219 增加bookData数据绑定获取
    bookData() {
      if (this.$store.state.book.bookData) {
        return this.$store.state.book.bookData
      } else {
        return {}
      }
    },
    // zjx 20221219 增加pageHandle数据绑定获取（默认双页展示）
    pageHandle() {
      if (this.$store.state.book.bookData) {
        if (this.$store.state.book.bookData.referer == 0) {
          return 1
        } else if (this.$store.state.book.bookData.referer > 0) {
          return 2
        } else {
          return 2
        }
      } else {
        return 2
      }
    },
    // zjx 20230103 用于控制移动端头部与底部的展示
    isMobile() {
      return this.$store.state.book.isMobile
    },
    currentPageIdx() {
      return this.$store.state.book.currentPage
    },
    // zjx 20230103 用于控制移动端头部与底部的展示
    timer() {
      return this.$store.state.book.timer
    },
    listToEditPageNo() {
      return this.$store.state.edit.listToEditPageNo
    },
    currentLang() {
      return this.$store.state.config.bookObj.language
    }
  },
  watch: {
    bookPath(val) {
      this.init.call(this)
    },
    currentPageNum(val) {
      this.isReady = false
      if (this.bookData.pages) {
        this.$nextTick(() => {
          this.getPageWH(val + 1, () => {
            // this.resizePage()
            // 关闭所有元素图片的状态及播放界面
            this.resNodeImgClose()
            // 加载某页面的热区数据
            this.loadXiaoYangList(val + 1)
          })
        })
      }
    },
    //个性化设置
    soundId: {
      handler(newId) {
        if (newId == 0) {
          this.playSrc = Default
        } else if (newId == 1) {
          this.playSrc = Thick
        } else if (newId == 2) {
          this.playSrc = Soft
        } else {
          this.playSrc = Default
        }
      },
      immediate: true
    }
  },
  methods: {
    imgTouch(e) {
      if (this.longPress === 0) {
        e.preventDefault()
      }
    },
    // 每次全屏状态改变后重置book样式
    fullScreenChange() {
      let isFullScreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen || document.msFullscreenElement
      if (isFullScreen) {
        this.$store.commit('book/UPDATE_IS_SHOW_COMMERHEADER', false)
        $('.edit-personal-wrapper .edit-personal').css({ height: window.screen.height - 310 + 'px' })
      } else {
        this.$store.commit('book/UPDATE_IS_SHOW_COMMERHEADER', true)
        $('.edit-personal-wrapper .edit-personal').css({ height: window.innerHeight - 390 + 'px' })
      }
      this.$nextTick(() => {
        this.reload()
      })
    },
    updateElementTransform() {
      this.mobile.el.style.transition = this.mobile.duration
      let tmp = this.mobile.tMatrix.join(',')
      this.mobile.el.style.transform = 'matrix(' + tmp + ')'
      this.mobile.ticking = false
    },
    /**
     * 查询富媒体列表
     * @param params
     * @param callback
     */
    getHotspotList(params, callback) {
      getBook.getHotspotList(params).then((res) => {
        if (res && res.data && res.status === 200) {
          callback(res.data.data)
        }
      })
    },
    /**
     * 数字报详情 - 大样列表
     * @param params
     * @param callback
     */
    getDaYangByEpaperId(params, callback) {
      getBook.getDaYangByEpaperId(params).then((res) => {
        if (res && res.data && res.status === 200) {
          callback(res.data.data)
        }
      })
    },
    /**
     * 数字报详情 - 小样列表
     * @param params
     * @param callback
     */
    getXiaoYangList(params, callback) {
      getBook.getXiaoYangList(params).then((res) => {
        if (res && res.data && res.status === 200) {
          callback(res.data.data)
        }
      })
    },
    getPageWH(page, callback) {
      // 判断页面当前是否已存在尺寸数据，如果存在，则无需再通过图片进行获取，而是直接返回即可
      let targetPage = this.bookData.pages[page - 1]
      if (targetPage === undefined) {
        callback && callback(0, 0)
        return
      }
      if (targetPage.width > 0 && targetPage.height > 0) {
        callback && callback(targetPage.width, targetPage.height)
        return
      }
      // 获取目标项目的尺寸数据
      let img = new Image()
      if (page === undefined) {
        if (this.pageHandle === 1) {
          // 单页展示（取第一页的尺寸）
          img.src = this.bookData.page[0].url
        } else {
          // 双页展示（取配置页的尺寸）【默认】
          img.src = this.bookData.page[this.referer - 1].url
        }
      } else {
        img.src = targetPage.url
      }
      img.onload = () => {
        // 目标尺寸数据
        let width = img.width
        let height = img.height
        targetPage.width = width
        targetPage.height = height
        callback && callback(width, height)
      }
    },
    loadXiaoYangList(page) {
      let width = this.bookData.pages[page - 1]?.width
      let height = this.bookData.pages[page - 1]?.height
      let dayangid = this.bookData.pages[page - 1]?.dayangid
      if (width === undefined || height === undefined || dayangid === undefined) {
        return
      }
      // 获取小样列表
      const params = {
        dayangId: dayangid
      }
      this.getXiaoYangList(params, (xiaoYangList) => {
        this.$store.commit('config/UPDATE_XIAOYANGLIST', !!xiaoYangList.length)
        let xiaoyangindex = 1
        this.bookData.pages[page - 1].coordinates = []
        for (let b in xiaoYangList) {
          if (xiaoYangList.hasOwnProperty(b)) {
            let dingDianCoords = []
            let coordinates = JSON.parse(xiaoYangList[b].coordinates)
            if (coordinates.dingDianCount === 1) {
              this.pages[page - 1].coordinates.push({
                type: 'area',
                top: coordinates.top,
                left: coordinates.left,
                width: coordinates.width,
                height: coordinates.height,
                topScale: coordinates.top,
                leftScale: coordinates.left,
                widthScale: coordinates.width,
                heightScale: coordinates.height,
                xiaoyangindex: xiaoyangindex++,
                zIndex: coordinates.zIndex >= 0 ? coordinates.zIndex : Math.abs(xiaoYangList.length - b - 1),
                xiaoyangid: xiaoYangList[b].id
              })
            } else {
              for (let c in coordinates.dingDianList) {
                if (coordinates.dingDianList.hasOwnProperty(c)) {
                  let x = (coordinates.dingDianList[c].split(',')[0].split('%')[0] * width) / 100
                  let y = (coordinates.dingDianList[c].split(',')[1].split('%')[0] * height) / 100
                  dingDianCoords.push(x)
                  dingDianCoords.push(y)
                }
              }
              let dingDianCoordsRect = this.dingDianCoords(dingDianCoords.toString())
              this.bookData.pages[page - 1].coordinates.push({
                type: 'area',
                top: dingDianCoordsRect.top,
                left: dingDianCoordsRect.left,
                width: dingDianCoordsRect.width,
                height: dingDianCoordsRect.height,
                topScale: dingDianCoordsRect.top,
                leftScale: dingDianCoordsRect.left,
                widthScale: dingDianCoordsRect.width,
                heightScale: dingDianCoordsRect.height,
                xiaoyangindex: xiaoyangindex++,
                zIndex: coordinates.zIndex || Math.abs(xiaoYangList.length - b - 1),
                xiaoyangid: xiaoYangList[b].id
              })
            }
          }
        }
        this.isReady = true
        setTimeout(() => {
          this.resizePageResNode()
        }, 10)
      })
    },
    /**
     *  初始化书 需要判断是否是移动端
     * turnCorners pc端可以设置四个角 bl,br,tl,tr 移动端设置bl,br
     *  pc端可以给第一第二页 倒第一到第二页加上hard 移动端只能给第一页加
     */
    init() {
      let _this = this
      let timers = new Date().getTime()
      this.getHotspotList({ module: 'epaper', moduleDataId: this.$route.query.id }, async (hotspotList) => {
        const params = {
          id: this.$route.query.id,
          module: 'epaper'
        }
        this.getDaYangByEpaperId(params, (daYangList) => {
          // 构建页面数据格式
          let pages = []
          let totalPages = _this.needPay && this.goodsObj.chargePage < this.totalPage ? this.goodsObj.chargePage : this.totalPage
          this.isShowContent = totalPages > 0
          for (let i = 1; i <= totalPages; i++) {
            let resources = []
            for (let b in hotspotList) {
              if (hotspotList.hasOwnProperty(b)) {
                if (i == hotspotList[b].pageIden) {
                  let type = undefined
                  if (hotspotList[b].contentType === 0) {
                    type = 'audio'
                  } else if (hotspotList[b].contentType === 1) {
                    type = 'video'
                  } else if (hotspotList[b].contentType === 2) {
                    type = 'link'
                  } else if (hotspotList[b].contentType === 3) {
                    type = 'picture'
                  } else if (hotspotList[b].contentType === 4) {
                    type = 'innerVideo'
                  }
                  let coordinates = JSON.parse(hotspotList[b].coordinates)
                  let res = {
                    id: hotspotList[b].id,
                    type: type,
                    top: coordinates.top,
                    left: coordinates.left,
                    width: coordinates.width,
                    height: coordinates.height,
                    topScale: coordinates.top,
                    leftScale: coordinates.left,
                    widthScale: coordinates.width,
                    heightScale: coordinates.height,
                    zindex: parseInt(b),
                    resize: false,
                    edit: false,
                    btnPath: coordinates.btnPath,
                    btnStyle: coordinates.btnStyle
                  }
                  if (type === 'link') {
                    res.href = hotspotList[b].contentPath
                    res.btnPath = hotspotList[b].btnPath
                    res.btnStyle = hotspotList[b].btnStyle
                  } else {
                    res.file = hotspotList[b].contentPath
                    res.fileid = hotspotList[b].fileAttachId
                    res.path = hotspotList[b].contentPath
                    res.controls = hotspotList[b].playControl === 1
                    res.autoplay = hotspotList[b].playAuto === 1
                    res.loopplay = hotspotList[b].playLoop === 1
                    res.btnPath = hotspotList[b].btnPath
                    res.btnStyle = hotspotList[b].btnStyle
                  }
                  if (type === 'video' || type === 'innerVideo') {
                    res.appID = hotspotList[b].appID
                    if (hotspotList[b].vodFileId) {
                      res.fileid = hotspotList[b].vodFileId
                    }
                    res.fileAttachId = hotspotList[b].fileAttachId
                  }
                  resources.push(res)
                }
              }
            }
            pages.push({
              url: this.bookData.path + '/' + daYangList[i - 1].pageNo + '.jpg' + (_this.isStaticBook ? '' : '?v=' + timers),
              index: i,
              width: 0,
              height: 0,
              resources: resources,
              coordinates: [],
              dayangid: daYangList[i - 1]?.id,
              pageNo: daYangList[i - 1].pageNo
            })
          }
          this.bookData.pages = pages
          //
          if (_this.isMobile && this.bookPath === 'nobook') {
            $('.mobile-footer-icon').css('margin-right', '0px')
            document.title = _this.shareTitle
            document.body.style.cssText += 'min-width:auto'
            _this.$store.commit('edit/UPDATE_EDIT_DRAWER_SHOW', false) // 移动端默认不显示目录
            return
          }
          // 初始化一个数组
          let arr = new Array(_this.totalPage)
          for (let i = 0; i < _this.totalPage; i++) {
            arr[i] = true
          }
          this.isloading = arr
          // zjx 20221219 根据页面处理类型，获取需要处理的图片的原始宽高
          if (this.pageHandle === 1) {
            // 单页展示（取第一页的尺寸）
            this.currentPageIndex = this.initPageIndex || 1
          } else {
            // 双页展示（取配置页的尺寸）【默认】
            this.currentPageIndex = this.referer
          }
          this.getPageWH(this.currentPageNum + 1, (imgWidth, imgHeight) => {
            let targetImageWidth = imgWidth
            let targetImageHeight = imgHeight

            // 加载某页面的热区数据
            this.loadXiaoYangList(this.currentPageNum + 1)

            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            // zjx 20221219 以下代码为之前的逻辑，我这边进行一点点调整，具体可以参考img.onload内部的代码（开始）
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

            // 设置书刊容器size，PC非数字报为双页模式，宽度为2w
            let w = targetImageWidth
            let h = targetImageHeight
            let finalW
            finalW = w
            _this.$store.commit('common/UPDATE_BOOK_SCALE', Number((finalW / h).toFixed(2)))

            //加载图片 TOFIX 图片加载是否可以移动到数据加载
            _this.$store.commit('book/UPDATE_PAGES', pages)
            _this.$nextTick(() => {
              _this.reload()
              _this.isReady = true
            })
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
            // zjx 20221219 结束
            //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
          })
        })
      })
    },
    reload() {
      if (this.isPaper) {
        // zjx 20221219 这里的自适应代码仅处理双页展示效果【默认】
        if (this.pageHandle !== 1) {
          let size = { bookHeight: parseInt($('.page-wrapper').height()), bookWidth: parseInt($('.page-wrapper').width()) }
          this.$store.commit('common/UPDATE_BOOK_SIZE', size)
        }
        // zjx 20221218 元素自适应
        this.resizePage()
        this.resizePageResNode()
      } else {
        let size = { bookHeight: parseInt($('.page-wrapper').height()), bookWidth: parseInt($('.page-wrapper').width()) }
        this.$store.commit('common/UPDATE_BOOK_SIZE', size)
        setTimeout(() => {
          this.resizePageResNode()
        }, 100)
      }
    },
    goload(index) {
      this.$set(this.isloading, index, false)
    },
    isDefaultIcon(src) {
      return src.includes('@imgs/digital') || src.includes('data:image/png;base64')
    },
    // 页面自适应 zjx 20221218
    resizePage() {
      // 获取窗口尺寸数据
      /*let windowWidth = parseInt($('.page-wrapper').width())
      let windowHeight = parseInt($('.page-wrapper').height())
      // 将窗口尺寸更新至UPDATE_BOOK_SIZE
      let size = { bookHeight: windowHeight, bookWidth: windowWidth }
      this.$store.commit('common/UPDATE_BOOK_SIZE', size)
      // 更新当前页面的尺寸
      let page = this.bookData.pages[this.currentPageIndex - 1]
      let scale = Math.min(windowWidth / page.width, windowHeight / page.height)
      let bookWidth = page.width * scale
      let bookHeight = page.height * scale
      if (this.bookWidth / this.bookHeight > this.bookScale) {
        $('.book-viewport').css({ width: bookWidth + 'px' })
      } else {
        $('.book-viewport').css({ height: bookHeight + 50 + 'px' })
      }*/
    },
    resizePageResNode() {
      let elePage = document.getElementById('book')
      let paperImg = document.getElementById('paperImg')
      if (!elePage || !paperImg) {
        return
      }
      let pageIndex = elePage.getAttribute('page')
      let eleWindowWidth = paperImg.offsetWidth
      let eleWindowHeight = paperImg.offsetHeight
      let pageData = this.bookData.pages[pageIndex - 1]
      //翻页时暂停视频
      let eleVideos = elePage.getElementsByTagName('video')
      let isCurrentPage = this.currentPageArray.includes(parseInt(pageIndex))
      for (let i = 0; i < eleVideos.length; i++) {
        if (!isCurrentPage) {
          eleVideos[i].pause()
        } else if (eleVideos[i].autoplay) {
          eleVideos[i].play()
        }
      }
      if (pageData.width === 0 || pageData.height === 0) {
        return
      }
      let eleResNodeList = elePage.getElementsByClassName('res-node')
      let scale = Math.min(eleWindowWidth / pageData.width, eleWindowHeight / pageData.height)
      if (scale === 0) {
        return
      }
      this.bookData.pages[pageIndex - 1].scale = scale
      for (let b in eleResNodeList) {
        if (eleResNodeList.hasOwnProperty(b)) {
          let width = pageData.width * scale
          let height = pageData.height * scale
          let top = (eleWindowHeight - height) / 2
          let left = (eleWindowWidth - width) / 2
          let eleResNode = eleResNodeList[b]
          let dataIndex = eleResNode.getAttribute('data-index')
          let dataType = eleResNode.getAttribute('data-type')
          let resNode = null
          if (dataType === 'area') {
            resNode = this.bookData.pages[pageIndex - 1].coordinates[dataIndex]
          } else {
            resNode = this.bookData.pages[pageIndex - 1].resources[dataIndex]
          }
          if (resNode) {
            resNode.widthScale = resNode.width * scale
            resNode.heightScale = resNode.height * scale
            resNode.topScale = resNode.top * scale + top
            resNode.leftScale = resNode.left * scale + left
            eleResNode.style.width = resNode.widthScale + 'px'
            eleResNode.style.height = resNode.heightScale + 'px'
            eleResNode.style.top = resNode.topScale + 'px'
            eleResNode.style.left = resNode.leftScale + 'px'

            //内嵌视频初始化
            if (dataType === 'innerVideo') {
              let videoEle = eleResNode.getElementsByTagName('VIDEO')
              if (videoEle && videoEle.length > 0) {
                continue
              }
              let eleSource = document.createElement('SOURCE')
              let eleVideo = document.createElement('VIDEO')
              if (resNode.btnPath && resNode.btnStyle === 1) {
                eleVideo.poster = resNode.btnPath
              }
              eleSource.src = resNode.path
              eleVideo.style = 'width:100%;height:100%'
              if (resNode.autoplay) {
                eleVideo.autoplay = resNode.autoplay
              }
              eleVideo.appendChild(eleSource)
              eleResNode.appendChild(eleVideo)
              let player = TCPlayer(eleVideo, {
                fileID: resNode.fileid,
                appID: resNode.appID || 1500010166,
                controls: resNode.controls,
                autoplay: resNode.autoplay,
                loop: resNode.loopplay,
                posterImage: false
              })
              this.addAttachPreview(resNode.fileAttachId)
            }
          }
        }
      }
    },
    resNodeImgClose() {
      // 如果存在播放界面，则先关闭及取消所有播放界面及状态
      let eleWin = document.getElementById('res-node-window')
      if (eleWin) {
        let eleWindow = document.getElementById('book')
        let elePageList = eleWindow.getElementsByClassName('page-wrapper')
        for (let a in elePageList) {
          if (elePageList.hasOwnProperty(a)) {
            let eleResNodeList = elePageList[a].getElementsByClassName('res-node')
            for (let b in eleResNodeList) {
              if (eleResNodeList.hasOwnProperty(b)) {
                let eleResNode = eleResNodeList[b]
                let dataType = eleResNode.getAttribute('data-type')
                if (dataType === 'audio' || dataType === 'video' || dataType === 'link') {
                  let eleImg = eleResNode.getElementsByTagName('IMG')

                  for (const el of eleImg) {
                    const eleImgIsDefault = this.isDefaultIcon(el.getAttribute('src'))
                    if (eleImgIsDefault) {
                      el.src = require('@imgs/digital/' + dataType + '.png')
                    }
                  }
                }
              }
            }
          }
          if (this.bgAudioPlayStatus) {
            document.getElementById('bgAudioFile').play()
          }
        }
        document.body.removeChild(eleWin)
      }
    },
    resNodeClick(e, res, item) {
      if (res.type === 'link') {
        if (res.href === 'pre') {
          this.prev()
        } else if (res.href === 'next') {
          this.next()
        } else if (res.href === 'first') {
          this.first()
        } else if (/^[0-9]+$/.test(res.href)) {
          this.setCurrentPage(res.href - 1)
        } else {
          window.open(res.href)
        }
      } else if (res.type === 'area') {
        this.$emit('onTurnedXiaoYang', res, item)
      }
    },
    resNodeImgClick(e, res) {
      this.resNodeImgClose()
      // 获取当前点击按钮的索引
      let currentResNodeDataIndex = parseInt(e.srcElement.parentNode.getAttribute('data-index')) + 1
      if (currentResNodeDataIndex === this.currentResNodeDataIndex) {
        // 同一个按钮
        this.currentResNodeDataIndex = 0
        return
      } else {
        // 不同按钮
        this.currentResNodeDataIndex = currentResNodeDataIndex
      }
      this.bgAudioPlayStatus = !document.getElementById('bgAudioFile').paused // 判断背景音乐当前是否正在播放
      //
      let eleWindow = document.createElement('DIV')
      let eleTitle = document.createElement('DIV')
      let eleClose = document.createElement('DIV')
      let eleImg = document.createElement('IMG')
      let eleBox = document.createElement('DIV')
      document.body.appendChild(eleWindow)
      eleImg.src = require('@imgs/digital/close-black.png')
      eleImg.style = 'width:16px;height:16px;'
      eleWindow.appendChild(eleTitle)
      eleWindow.appendChild(eleClose)
      eleWindow.appendChild(eleBox)
      eleWindow.id = 'res-node-window'
      eleWindow.style = 'position:absolute;top:' + e.pageY + 'px;left:' + e.pageX + 'px;z-index:9999;background:#e3e3e3;border:1px solid #999999;'
      eleTitle.style = 'padding:5px;line-height:24px;font-size:16px;'
      eleClose.style = 'position:absolute;right:0;top:0;width:34px;height:34px;text-align:center;line-height:34px;cursor:pointer;'
      eleClose.appendChild(eleImg)
      eleClose.onclick = () => {
        this.resNodeImgClose()
        // this.currentResNodeDataIndex = 0
        return
        if (res.type === 'audio') {
          if (this.bgAudioPlayStatus) {
            document.getElementById('bgAudioFile').play()
          }
          if (res.btnPath) {
            e.target.src = require(res.btnPath)
          } else {
            e.target.src = require('@imgs/digital/audio.png')
          }
        } else if (res.type === 'video') {
          if (this.bgAudioPlayStatus) {
            document.getElementById('bgAudioFile').play()
          }
          if (res.btnPath) {
            e.target.src = require(res.btnPath)
          } else {
            e.target.src = require('@imgs/digital/video.png')
          }
        } else if (res.type === 'link') {
          if (res.btnPath) {
            e.target.src = require(res.btnPath)
          } else {
            e.target.src = require('@imgs/digital/link.png')
          }
        }
        this.currentResNodeDataIndex = 0
        document.body.removeChild(eleWindow)
      }
      eleBox.style = 'padding: 10px;'
      if (res.type === 'audio') {
        let eleAudio = new Audio()
        eleAudio.src = res.path
        eleAudio.controls = res.controls
        eleAudio.loop = res.loopplay
        eleBox.appendChild(eleAudio)
        eleTitle.innerText = '音频'
        // if (res.btnPath) {
        //   e.target.src = require(res.btnPath)
        // } else {
        // e.target.src = require('@imgs/digital/audio-selected.png')
        // }
        if (this.isDefaultIcon(res.btnPath) || res.btnStyle === 0) {
          e.target.src = require('@imgs/digital/audio-selected.png')
        }
        if (res.controls === false) {
          eleWindow.style.display = 'none'
        }
        if (res.autoplay) {
          eleAudio.play()
        }
        if (this.isMobile) {
          eleWindow.style = 'position:absolute;top:0;left:0;width:100%;z-index:9999;background:#e3e3e3;'
          eleAudio.style = 'width:80%;height:34px;margin:3px auto;'
          eleTitle.style = 'display:none;'
          eleBox.style = 'font-size:0;line-height:0;text-align:center;'
          eleClose.style = 'position:absolute;right:3px;top:3px;width:34px;height:34px;text-align:center;line-height:34px;cursor:pointer;'
        }
        if (this.bgAudioPlayStatus) {
          document.getElementById('bgAudioFile').pause()
        }
        this.addAttachPreview(res.fileid)
      } else if (res.type === 'video') {
        let eleSource = document.createElement('SOURCE')
        let eleVideo = document.createElement('VIDEO')
        eleSource.src = res.path
        eleSource.type = 'video/mp4'
        eleVideo.style = 'max-width:500px;'
        eleVideo.appendChild(eleSource)
        eleBox.appendChild(eleVideo)
        eleTitle.innerText = '视频'
        // if (res.btnPath) {
        //   e.target.src = require(res.btnPath)
        // } else {
        // e.target.src = res.btnPath
        // e.target.src = require('@imgs/digital/video-selected.png')

        // }
        if (this.isDefaultIcon(res.btnPath) || res.btnStyle === 0) {
          e.target.src = require('@imgs/digital/video-selected.png')
        }
        if (this.isMobile) {
          eleWindow.style = 'position:absolute;top:0;left:0;width:100%;height:100%;z-index:9999;background:#e3e3e3;'
          eleVideo.style = 'width:100%;height:100%;'
          eleBox.style = 'object-fit: contain;width:100%;height:calc(100% - 45px);'
        } else {
          eleWindow.style = 'position:absolute;top:50%;left:50%;z-index:9999;background:#e3e3e3;opacity:0;'
          eleVideo.style = 'max-width:500px;max-height:500px;'
          eleVideo.oncanplay = () => {
            eleWindow.style.marginLeft = -(eleWindow.offsetWidth / 2) + 'px'
            eleWindow.style.marginTop = -(eleWindow.offsetHeight / 2) + 'px'
            eleWindow.style.opacity = '1'
          }
        }
        let player = TCPlayer(eleVideo, {
          fileID: res.fileid,
          appID: res.appID || '',
          controls: res.controls,
          autoplay: res.autoplay,
          loop: res.loopplay
        })
        this.addAttachPreview(res.fileAttachId)
        player.on('fullscreenchange', function() {
          if (player.isFullscreen()) {
            eleVideo.style = ''
          } else {
            eleVideo.style = 'max-width:500px;max-height:500px;'
          }
        })
        if (this.bgAudioPlayStatus) {
          document.getElementById('bgAudioFile').pause()
        }
      }
    },
    resNodeImgSingletap(e) {
      if (this.isMobile && e.type === 'singletap' && e.target.className.indexOf('fd-js-excludes') < 0) {
        clearTimeout(this.timer)
        this.$store.commit('book/UPDATE_IS_SHOW_FOOTER', false)
        this.$store.commit('book/UPDATE_IS_SHOW_TITLE', false)
      }
    },
    dingDianCoords(dingDianCoords) {
      let arr = dingDianCoords.split(',')
      let xArr = new Array(arr.length / 2)
      let yArr = new Array(arr.length / 2)
      let x = 0,
        y = 0
      let max = 1,
        min = 2
      for (let t = 0; t < arr.length; t = t + 2) {
        xArr[x++] = parseInt(arr[t])
      }
      for (let t = 1; t < arr.length; t = t + 2) {
        yArr[y++] = parseInt(arr[t])
      }
      let x1 = this.find(xArr, min)
      let x2 = this.find(xArr, max)
      let y1 = this.find(yArr, min)
      let y2 = this.find(yArr, max)
      let Left = x1
      let Top = y1
      let Right = parseInt(x2 - x1)
      let Bottom = parseInt(y2 - y1)
      return {
        top: Top,
        left: Left,
        width: Right,
        height: Bottom
      }
    },
    find(arr, type) {
      let tmp = arr[0]
      if (type == 1) {
        for (let loop = 0; loop < arr.length; loop++) if (arr[loop] > tmp) tmp = arr[loop]
        return tmp
      } else if (type == 2) {
        for (let loop = 0; loop < arr.length; loop++) if (arr[loop] < tmp) tmp = arr[loop]
        return tmp
      }
    },
    addAttachPreview(id) {
      const params = {
        fileAttachId: id
      }
      home.addAttachPreview(params)
    },
    resizeDiv() {
      let appDiv = $('#app')
      let appSize = { height: parseInt(appDiv.height()), width: parseInt(appDiv.width()) }
      this.$store.commit('common/UPDATE_APP_SIZE', appSize)
      if (this.isMobile) {
        this.mobile.tMatrix[0] = this.mobile.tMatrix[3] = 1
        this.mobile.tMatrix[4] = this.mobile.tMatrix[5] = 0
        this.updateElementTransform()
        this.reload()
      } else {
        this.reload()
      }
    },

    setCurrentPage(pageIndex) {
      this.$store.commit('book/UPDATE_CURRENT_PAGE', [pageIndex + 1])
      this.$emit('onTurned', pageIndex + 1)
    },
    next() {
      if (this.currentPageNum < this.totalPage - 1) {
        this.setCurrentPage(this.currentPageNum + 1)
        this.$parent.pageIndex = this.currentPageNum + 1
      }
    },
    prev() {
      if (this.currentPageNum != 0) {
        this.setCurrentPage(this.currentPageNum - 1)
        // this.$parent.pageIndex = this.currentPageNum + 1
      }
    },
    first() {
      this.setCurrentPage(0)
      this.$parent.pageIndex = 1
    },
    last() {
      this.setCurrentPage(this.totalPage - 1)
      this.$parent.pageIndex = this.totalPage
    }
  },
  created() {
    this.init()
    /*let isIframe = self !== top
    this.readingLog = JSON.parse(localStorage.getItem('readingLog')) || {}
    if (Object.keys(this.readingLog).length > 0 && this.readingLog[this.decryption_id]) {
      this.$nextTick(() => {
        // 双页的可能存储为0，如果为0处理为1
        this.initPage = this.readingLog[this.decryption_id] == 0 ? 1 : this.readingLog[this.decryption_id]
        this.$message({
          message: '已为您定位到上次浏览的位置',
          duration: 5000,
          customClass: this.isMobile ? 'el-message-class-memmb' : isIframe || !this.isShowCommerHeader ? 'el-message-class-mempc-content' : 'el-message-class-mempc',
          center: true,
          type: 'info'
        })
      })
    }*/
  },
  mounted() {
    // 监听全屏变化，每次变化后重置book样式
    const arr = ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'msfullscreenchange']
    arr.forEach((item) => {
      document.addEventListener(item, this.fullScreenChange)
    })
    wx.ready(() => {
      this.$refs.audio.play()
      this.$refs.audio.pause()
    })
    this.$store.commit('book/UPDATE_IS_MOBILE', judgeIsMobile())
    let size = { bookHeight: parseInt($('.book-viewport ').height()), bookWidth: parseInt($('.book-viewport ').width()) }
    this.$store.commit('common/UPDATE_BOOK_SIZE', size)
    window.onresize = () => {
      this.resizeDiv()
    }
  },
  beforeDestroy() {
    let eleWin = document.getElementById('res-node-window')
    if (eleWin) {
      document.body.removeChild(eleWin)
    }
    this.currentResNodeDataIndex = 0
  },
  destroyed() {
    window.onresize = null
    this.$store.commit('book/UPDATE_CURRENT_PAGE', [0, 1])
    this.$store.commit('book/UPDATE_PAGES', [])
    this.$store.commit('book/UPDATE_BOOK_PATH', '')
    this.$store.commit('book/UPDATE_IS_ZOOM', false)
    this.$store.commit('book/UPDATE_ZOOM', 1)
    $('.book-viewport').css({ height: '100%', width: '100%' })
    const arr = ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'msfullscreenchange']
    arr.forEach((item) => {
      document.removeEventListener(item, this.fullScreenChange)
    })
  }
}
</script>
<style lang="scss" scoped>
.no-touch {
  pointer-events: none;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  vertical-align: sub;
}
.turn-paper-outer {
  height: 695px;
  width: 460px;
  display: inline-block;
  margin-right: 20px;
  vertical-align: top;
  flex-shrink: 0;
}
.turn-book-container {
  height: 695px;
  width: 460px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  //flex-shrink: 0;
  .page-wrapper {
    //width: fit-content;
    width: 100%;
    max-width: 100%;
    position: relative;
    max-height: 658px !important;
    text-align: center;
    img {
      object-fit: contain;
      height: 100%;
      width: 100%;
    }

    .res-node {
      position: absolute;
      img {
        position: absolute;
        top: 0;
        right: 0;
        width: 32px;
        height: 32px;
      }
    }
    .area {
      cursor: pointer;
      &:hover {
        background: rgba(0, 0, 0, 0.1);
      }
    }
    .link {
      cursor: pointer;
      &:hover {
        background: rgba(0, 0, 0, 0.1);
      }
    }
    .picture {
      background-size: contain;
      background-repeat: no-repeat;
    }
    .audio {
      img {
        cursor: pointer;
      }
    }
    .video {
      img {
        cursor: pointer;
      }
    }
  }

  .page-opt {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 27px;
    padding: 3px 6px;
    margin-top: 10px;
    background: #e2e2e2;
    h4 {
      margin: 0;
    }
    div {
      cursor: pointer;
      span {
        margin-right: 5px;
      }
    }
  }
}
</style>
